import PromotionsTable from './PromotionsTable';

export default PromotionsTable;
